import React, { useEffect, useState } from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import textLabels from 'utils/MUIDataTableTextLabels'
import MUIDataTable from 'mui-datatables'
import { format } from 'date-fns'

import {
  Dialog,
  Button,
  DialogContent,
  DialogActions,
  Typography,
  DialogTitle,
  CircularProgress,
  TextField,
  Grid,
} from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import { URL_API_CARGAS_DETALLES } from 'constantes/urls'

const useStyles = makeStyles((theme) => ({
  inputForm: {
    marginLeft: 20,
  },
  divForm: {
    marginBottom: 20,
  },
}))

const ModalDetalle = ({ open, handleClose, carga }) => {
  const classes = useStyles()
  const [detalles, setDetalles] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const obtenerDetalle = async (idCarga) => {
      try {
        const resultado = await axios.get(`${URL_API_CARGAS_DETALLES.replace('@idCarga', idCarga)}`)

        if (resultado) {
          setDetalles(resultado.data)
        }
      } catch (error) {
        console.log('Ocurrió un error al consultar los detalles', error)
      }
    }
    obtenerDetalle(carga[0])
  }, [carga])

  const options = {
    print: false,
    filter: false,
    viewColumns: false,
    filterType: 'dropdown',
    responsive: 'scrollMaxHeight',
    rowHover: true,
    selectableRows: 'none',
    textLabels,
  }

  const columns = [
    {
      name: 'id',
      label: 'Radicado',
    },
    {
      name: 'fechaDeProcesamiento',
      label: 'Fecha de procesamiento',
      options: {
        customBodyRender: (value) => format(new Date(value), 'yyyy-MM-dd  HH:mm:ss'),
      },
    },
    {
      name: 'alfa',
      label: 'Alfa',
    },
    {
      name: 'numeroFactura',
      label: 'Factura',
    },
    {
      name: 'procesamientoOk',
      label: 'Carga exitosa',
      options: {
        customBodyRender: (value) => (value === false ? 'No' : 'Si'),
      },
    },
    {
      name: 'nombreArchivo',
      label: 'Nombre archivo',
    },
    {
      name: 'notaProcesamiento',
      label: 'Nota procesamiento',
    },
    {
      name: 'procesoP8Exitoso',
      label: 'Carga P8 exitosa',
      options: {
        customBodyRender: (value) => (value === false ? 'No' : 'Si'),
      },
    },
  ]

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='carga-detalle'
      aria-describedby='carga-detalle'
      maxWidth='xl'
    >
      <DialogTitle id='form-dialog-title'>Detalle de la carga {carga.id}</DialogTitle>
      <DialogContent>
        <Grid container justify='center' className={classes.divForm}>
          <TextField readOnly label='Carga id' value={carga[0]} />
          <TextField readOnly label='Fecha carga' value={carga[2]} className={classes.inputForm} />
          <TextField readOnly label='NIT' value={carga[3]} className={classes.inputForm} />
          <TextField readOnly label='Alfa' value={carga[4]} className={classes.inputForm} />
          <TextField readOnly label='Factura' value={carga[5]} className={classes.inputForm} />
        </Grid>
        <MUIDataTable
          title={
            <Typography variant='h6'>
              Lista de archivos
              {isLoading && (
                <CircularProgress
                  size={24}
                  style={{ marginLeft: 15, position: 'relative', top: 4 }}
                />
              )}
            </Typography>
          }
          data={detalles}
          columns={columns}
          options={options}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant='outlined' color='primary' autoFocus>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ModalDetalle.propTypes = {
  carga: PropTypes.array,
}
export default React.memo(ModalDetalle)
